import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { SerializedEditorState } from 'lexical';

export const LoadEditorStatePlugin = ({ editorStateJson }: { editorStateJson: SerializedEditorState }) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editorStateJson) return;

    const parsedEditorState = editor.parseEditorState(editorStateJson);
    editor.setEditorState(parsedEditorState);
    
  }, [editor, editorStateJson]);

  return null;
};
